import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmChevronRightCircle } from '@websolutespa/bom-mixer-icons';
import { ReactNode } from 'react';
import { LlmBlock, LlmChunkCard, LlmChunkCardItem, LlmChunkCardThron, LlmChunkCardVideo } from '../../../types';
import { ThronPlayer } from '../../components/ThronPlayer/thron-player';
import { VideoPlayer } from '../../components/VideoPlayer/video-player';

export const CardWrapper = ({ children, ...props }: (LlmChunkCardItem | LlmChunkCard) & { children: ReactNode }) => {
  // const label = useLabel();
  const classNames = getClassNames('llm__card', `llm__card--${props.cardType}`);
  return (
    <div className={classNames}>
      {children}
    </div>
  );
};

export const Card: React.FC<LlmBlock<LlmChunkCardItem | LlmChunkCard>> = (props) => {
  const { item } = props;
  const label = useLabel();
  return (
    <CardWrapper {...item}>
      {item.media.type === 'image' && item.cta.url && (
        <a className="llm__card-media" href={item.cta.url} target="_blank" rel="noreferrer" aria-label={item.cta.label || label('llm.tellMeMore')}>
          <div className="llm__card-asset">
            <img src={item.media.src} alt="" />
          </div>
        </a>
      )}
      {item.media.type === 'image' && !item.cta.url && (
        <div className="llm__card-media">
          <div className="llm__card-asset">
            <img src={item.media.src} alt="" />
          </div>
        </div>
      )}
      {item.media.type === 'video' && (
        <div className="llm__card-media">
          <div className="llm__card-asset">
            <VideoPlayer {...item as LlmChunkCardVideo} />
          </div>
        </div>
      )}
      {item.media.type === 'thron' && (
        <div className="llm__card-media">
          <div className="llm__card-asset">
            <ThronPlayer {...item as LlmChunkCardThron} />
          </div>
        </div>
      )}
      <div className="llm__card-content">
        {item.date && (
          <div className="llm__card-date">{item.date}</div>
        )}
        {item.title && (
          <div className="llm__card-title" dangerouslySetInnerHTML={{ __html: item.title }} />
        )}
        {item.abstract && (
          <div className="llm__card-abstract" dangerouslySetInnerHTML={{ __html: item.abstract }} />
        )}
        {item.cta && item.cta.url && (
          <a className="llm__card-cta" href={item.cta.url} target="_blank" rel="noreferrer">
            <span>{item.cta.label || label('llm.tellMeMore')}</span> <IconLlmChevronRightCircle />
          </a>
        )}
      </div>
    </CardWrapper>
  );
};

